import { useEffect, useRef, useState } from "react";

import { bizAdvisorService, type DiagnosisDetail } from "../api/bizAdvisorService";
import { errorText } from "@/shared/lib/apiErrors";

/** 轮询某次诊断直到终态(SUCCESS/FAILED);RUNNING 时每 2.5s 拉一次。 */
export function useDiagnosisPolling(diagnosisId: number | null) {
  const [diagnosis, setDiagnosis] = useState<DiagnosisDetail | null>(null);
  const [error, setError] = useState<string | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!diagnosisId) {
      setDiagnosis(null);
      setError(null);
      return;
    }
    let cancelled = false;

    const loop = async () => {
      try {
        const d = await bizAdvisorService.getDiagnosis(diagnosisId);
        if (cancelled) return;
        setDiagnosis(d);
        setError(null);
        if (d.status === "RUNNING") {
          timerRef.current = setTimeout(() => void loop(), 2500);
        }
      } catch (e: unknown) {
        if (cancelled) return;
        setError(errorText(e));
      }
    };

    void loop();

    return () => {
      cancelled = true;
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [diagnosisId]);

  return { diagnosis, error };
}
